import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getBenefitDocuments = ({ groupId }) =>
  call(websocketFetch, 'get_benefit_documents', { group_id: groupId });
